import { SelectProps } from '@mui/material';
import { CellTypingJob, JobType } from 'interfaces/job';
import React, { ReactElement } from 'react';
import JobSelect from './JobSelect';

interface CellTypingJobSelectProps extends Omit<SelectProps, 'onScroll' | 'label'> {
  selectedCellTypingJobId: string | null;
  setSelectedCellTypingJobId: (jobId: string | null) => void;
  restoredJobOrchestrationId?: string | null;
  onJobSelect: (job: CellTypingJob) => void;
  autoAssignLastJob?: boolean;
  helperText?: string;
  studyId?: string;
  field?: string;
  errors?: any;
  cellTypingJobError?: string;
}

export const CellTypingJobSelect = ({
  selectedCellTypingJobId,
  setSelectedCellTypingJobId,
  restoredJobOrchestrationId,
  onJobSelect,
  autoAssignLastJob,
  helperText,
  studyId,
  field = 'cellTypingJobId',
  errors: errorsFromProps,
  cellTypingJobError,
  ...selectProps
}: CellTypingJobSelectProps): ReactElement => {
  const errors = {
    ...(errorsFromProps || {}),
    [field]: { message: cellTypingJobError },
  };

  return (
    <JobSelect
      label="Cell Typing Job"
      selectedJobId={selectedCellTypingJobId}
      setSelectedJobId={setSelectedCellTypingJobId}
      orchestrationIds={
        !selectedCellTypingJobId && restoredJobOrchestrationId ? [restoredJobOrchestrationId] : undefined
      }
      onLoadFullJob={onJobSelect}
      autoAssignLastJob={autoAssignLastJob || Boolean(!selectedCellTypingJobId && restoredJobOrchestrationId)}
      helperText={helperText}
      studyId={studyId}
      {...selectProps}
      jobType={JobType.MultiplexCellTyping}
      field={field}
      errors={errors}
    />
  );
};
